import { render } from "./EditAddressModal.vue?vue&type=template&id=1650927e&scoped=true"
import script from "./EditAddressModal.vue?vue&type=script&lang=js"
export * from "./EditAddressModal.vue?vue&type=script&lang=js"

import "./EditAddressModal.vue?vue&type=style&index=0&id=1650927e&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1650927e"]])

export default __exports__